// 产品介绍页面中跳转控制台 前的权限校验
import { cookies } from "@/common/cookieUtils";
// import router from '../router'
import store from "../store/index.js";

/*
  *返回状态码
    2： 未登录，
    1： 登录且有权限
    0： 登录但没有权限
*/
function judgePolicy(menuUrl) {
  return cookies.getAuthorization().then(token => {
    if (localStorage.getItem("menuData") && token) {
      let menuData = JSON.parse(localStorage.getItem("menuData"));
      let judge = false;
      menuData.forEach(item => {
        item.menu.forEach(it => {
          if (it.menuUrl === menuUrl) {
            judge = true;
          }
        });
      });
      if (judge) {
        return 1;
      } else {
        return 0;
      }
    } else {
      return 2;
    }
  });
}
function toPath(arg) {
  if (arg.bool === 1) {
    let obj = arg.name ? { name: arg.name } : { path: arg.path };
    // router.push(obj);
    alert("路由到地址:" + obj);
  } else if (arg.bool === 0) {
    arg.that.$Notice.warning({
      title: "您未拥有此权限",
      desc: "获取权限请联系管理员！"
    });
  } else if (arg.bool === 2) {
    store.commit("changeloginBeforePath", {
      path: arg.path,
      menuUrl: arg.menuUrl
    });
    router.push({ path: "login" });
  }
}

export const commonFunc = {
  judgePolicy,
  toPath
};



// WEBPACK FOOTER //
// ./src/common/commonFunction.js